<ui-assignee-avatar [uiAssignee]="assignee" [uiSize]="size" uiAlt=""></ui-assignee-avatar>

<ui-assignee-name
  [uiAssignee]="assignee"
  [uiEllipsis]="nameEllipsis"
  [uiAlign]="nameAlign"
  [uiMultiline]="nameMultiline"
  [uiSuffix]="nameSuffix"
  [attr.data-test-id]="assignee?.name ? 'assignee-name-' + assignee.name : 'assignee-name'"></ui-assignee-name>
